import React, { useEffect, useState } from 'react'
import OpenBtn from '../../buttons/OpenBtn'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import { ROUTE_IMG_DEFAULT } from '../../../constantes/routes'
import { getUrlFromAStream } from '../../../utils/getUrlByFileStream'

const ProductPresentationCard = (
    {
        product,
        isEditPresentation,
        goToViewDetailProduct,
        handleRemovePresentationProduct,
        toEditPresentationProduct,
        handleDownloadDocument
    }
) => {
    const [coverImg, setCoverImg] = useState(ROUTE_IMG_DEFAULT)
  
    useEffect(async () =>{
        if(product.rutaCoverImg !== ''){
            await getBobImg(product.rutaCoverImg)
        }
    }, [])

    const getBobImg = async (urlFTP) => {
        const coverImg = await getUrlFromAStream(urlFTP, 'application/imagen') 
        setCoverImg(coverImg)
    }  

    //CUIDADO LOS PRODUCTOS ELIMINADOS EL CONTACTO NO DEBERIA VERLO
    const IsTheArticleDeleted = (isActive) => {
        return isActive ? {opacity: "initial" } : {opacity: "0.5" }
    }

    return (
        <>
            <div className="card__horizontal " style={IsTheArticleDeleted(product.isActivo)}>
                <div className="card__horizontal__details" >
                    <img loading="lazy" className="card__horizontal__img" src={coverImg} alt="img-product"/>
                    <div>
                        <ul>
                            {
                                product.nombreDocumentos.length > 0  ? product.nombreDocumentos.map((doc, i) =>
                                  <li key={i} style={{display: "flex", alignItems: "baseline"}} className="products__text">{doc}</li>
                                ) : null
                            }
                             
                        </ul>
                    </div>
                </div>

                <div className="card__buttons">
            
                    {
                        product.isActivo ?
                            isEditPresentation ?
                            <div className="add__action__rigth__side">
                                <button onClick={() => toEditPresentationProduct(product.id_Articulo)}> <EditBtn /></button>
                                <button onClick={() => handleRemovePresentationProduct(product.id_Articulo)}><DeleteBtn /></button>
                            </div>
                            :
                            <div className="add__action__rigth__side">
                                <button className="btn-filter button-bg btn-shape" onClick={() => goToViewDetailProduct(product.id_Articulo)}> <OpenBtn /> Ver</button>
                            </div>
                        : 
                        null
                    }

                </div>
            </div>
            <hr className="products__separator" />
        </>
    )
}
export default ProductPresentationCard